import {dateTime, name} from '@management-ui/core';
import {Button, Typography} from '@mui/material';
import {makeStyles} from '@mui/styles';
import React, {useCallback, useRef, useState} from 'react';
import Text from './Text';
import NoteForm from '../modules/admin/forms/NoteForm';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    width: '100%',
  },

  column: {
    flex: 1,

    '& h3': {
      color: theme.palette.secondary.main,
      flex: 1,
      fontSize: '1.4em',
      margin: `${theme.spacing(1.6)} ${theme.spacing(1)} 0`,
      padding: 0,
    },

    '&:last-of-type': {
      borderLeft: `2px solid ${theme.palette.grey['200']}`
    }
  },

  form: {
    '& .MuiButton-root': {
      margin: `0 0 ${theme.spacing(2)} ${theme.spacing(2)}`,
    },
  },

  noNotes: {
    padding: `${theme.spacing(3)} ${theme.spacing(2)}`,
  },

  note: {
    backgroundColor: theme.palette.common.white,
    display: 'flex',
    flexWrap: 'wrap',

    '&:nth-child(even)': {
      backgroundColor: theme.palette.grey['100'],
    },

    '& .MuiTypography-root': {
      margin: 0,
      padding: theme.spacing(1),
    },

    '& .MuiTypography-subtitle1': {
      flex: '0 0 100%',
      fontSize: '1em',
      paddingBottom: 0,
      width: '100%'
    },

    '& .MuiTypography-subtitle2': {
      color: theme.palette.secondary.main,
      flex: '0 0 50%',
      fontSize: '0.9em',
      fontWeight: 600,
      width: '50%',

      '&:last-of-type': {
        textAlign: 'right',
      }
    }
  }
}));

const Notes = ({entity, onEntityUpdated, onSave, type}) => {
  const classes = useStyles();
  /** @type {({current: NoteForm})} */
  const formRef = useRef();
  const [note, setNote] = useState({});

  const handleSaved = useCallback((saved) => {
    setNote({});
    onEntityUpdated(saved);
  }, [onEntityUpdated]);

  return (
    <div className={classes.container}>
      <div className={classes.column}>

        <div className={classes.form}>
          <h3>Notes</h3>
          {entity.archived ? (
            <Typography className={classes.noNotes}>
              Notes can not be added to this {type} as it is archived.
            </Typography>
          ) : (
            <>
              <NoteForm
                ref={formRef}
                note={note}
                onSave={onSave}
                onSaved={handleSaved}
              />
              <Button variant="contained" onClick={() => formRef.current.save()}>Save</Button>
            </>
          )}
        </div>
      </div>
      <div className={classes.column}>
        {entity.notes.length < 1 ? (
          <Typography className={classes.noNotes}>There are no notes associated with this {type}</Typography>
        ) : (
          entity.notes.map((note, index) => (
            <div key={index} className={classes.note}>
              <Typography variant="subtitle1"><Text text={note.comment}/></Typography>
              <Typography variant="subtitle2">{name(note.user)}</Typography>
              <Typography variant="subtitle2">{dateTime(note.created_at)}</Typography>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Notes;
